import {
  getRatingList,
  getRatingDetail,
  getSurveyList,
  getSurveyDetail,
} from '@/services/ratingsurvey';

const getters = {
  listRatings: state => state.listRatings,
  listSurveys: state => state.listSurveys,
  per_page: state => state.per_page,
};

const actions = {
  async requestListRatings({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getRatingList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_RATING', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListSurveys({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getSurveyList({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST_SURVEY', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailRating({ commit, dispatch, rootGetters }, idRating) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let result;
    try {
      result = await getRatingDetail({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, idRating);
      result = result.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return result;
  },
  async requestDetailSurvey({ commit, dispatch, rootGetters }, idSurvey) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let result;
    try {
      result = await getSurveyDetail({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, idSurvey);
      result = result.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return result;
  },
};

const mutations = {
  SET_LIST_RATING(state, listRatings) {
    state.listRatings = listRatings;
  },
  SET_LIST_SURVEY(state, listSurveys) {
    state.listSurveys = listSurveys;
  },
};

export default {
  namespaced: true,
  state: {
    listRatings: [],
    listSurveys: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/RatingSurvey/index.js